// Reasons why online cancellation is unavailable.
// Used by useAbleCancelEntireBooking to communicate specific reasons to the UI.
export const CANCEL_REASONS = {
  HAS_ACCOMMODATION_OR_EXPERIENCE: 'HAS_ACCOMMODATION_OR_EXPERIENCE',
  TIME_RESTRICTED: 'TIME_RESTRICTED',
  ALREADY_TRAVELLED: 'ALREADY_TRAVELLED',
};

// Reasons why online modification is unavailable.
// Used by useCurrentBookingState to communicate specific reasons to the UI.
export const MODIFY_REASONS = {
  FROM_SYS_ADMIN: 'FROM_SYS_ADMIN',
  TIME_RESTRICTED: 'TIME_RESTRICTED',
  NOT_SIMPLE_BOOKING: 'NOT_SIMPLE_BOOKING',
  ALREADY_TRAVELLED: 'ALREADY_TRAVELLED',
};

// Check if a date string (YYYY-MM-DD) is in the past relative to today.
export const isDateInPast = (dateString) => {
  if (!dateString) return false;
  const today = new Date().toISOString().split('T')[0];
  return dateString < today;
};
